import { render, staticRenderFns } from "./JBProposalSafeValues.vue?vue&type=template&id=7da738a3"
import script from "./JBProposalSafeValues.vue?vue&type=script&lang=js"
export * from "./JBProposalSafeValues.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports